module.exports = __webpack_public_path__ + "static/img/threeBG.623e043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/threeBG.png
// module id = 4kH5
// module chunks = 1